module.exports = __webpack_public_path__ + "static/media/logo.acb5a379.svg";